import { render, staticRenderFns } from "./MsalLoginButton.vue?vue&type=template&id=1a57f3b8&"
import script from "./MsalLoginButton.vue?vue&type=script&lang=ts&"
export * from "./MsalLoginButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports